import React from 'react'

const OutOfState = () => {
    const schoolData =
        [
            {
                "Bank Name": "Banterra Bank",
                "Address": "6965 UNION PK CTR DR STE 260, COTTONWOOD HEIGHTS, UT 84047",
                "CEO/President": "Robert J. May, President",
                "Contact No:": "385-645-3005"
            },
            {
                "Bank Name": "D.L. Evans Bank",
                "Address": "312 W MAIN ST, TREMONTON, UT 84337",
                "CEO/President": "John V. Evans, Jr., President",
                "Contact No:": "435-257-2265"
            },
            {
                "Bank Name": "Fortis Private Bank",
                "Address": "6975 UNION PK AVE STE 180, COTTONWOOD HEIGHTS, UT 84047",
                "CEO/President": "Joel Coursey, Chief Operating Officer",
                "Contact No:": "385-275-5603"
            },
            {
                "Bank Name": "Glacier Bank",
                "Address": "49 COMMONS LOOP, KALISPELL, MT 59901",
                "CEO/President": "Randy Chesler, President",
                "Contact No:": "208-415-5310"
            },
            {
                "Bank Name": "Goldman Sachs Bank USA",
                "Address": "222 S MAIN ST, SALT LAKE CITY, UT 84101",
                "CEO/President": "Carey Halio, Treasurer",
                "Contact No:": "801-884-1500"
            },
            {
                "Bank Name": "NBH Bank dba Hillcrest Bank",
                "Address": "810 N 500 W,BOUNTIFUL, UT 84010",
                "CEO/President": "David Stahl, Utah Market President",
                "Contact No:": "385-300-7250"
            },
            {
                "Bank Name": "Umpqua Bank",
                "Address": "10757 S RIVER FRONT PKWY STE 275, SOUTH JORDAN, UT 84095",
                "CEO/President": "Clint Stein, CEO",
                "Contact No:": "385-425-7321"
            },
            {
                "Bank Name": "Washington Federal",
                "Address": "505 E 200 S, SALT LAKE CITY, UT 84102",
                "CEO/President": "Brent Beardall, CEO",
                "Contact No:": "801-366-2265"
            }
        ]

    const getGoogleMapsUrl = (address) =>
      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        address
      )}`;

    return (
      <div className="flex items-center justify-center my-12">
        <div className="bg-gray-300 z-10 rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
          <div className="overflow-x-auto max-h-[800px]">
            <table className="table-auto border-collapse border bg-white border-gray-300 w-full">
              <thead className="sticky top-0 z-10">
                <tr>
                  <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-left">
                    Bank Name
                  </th>
                  <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-left">
                    Address
                  </th>
                  <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-left">
                    Contact No
                  </th>
                </tr>
              </thead>
              <tbody>
                {schoolData.map((school, index) => (
                  <tr
                    key={`${school["Bank Name"]}-${index}`}
                    className="odd:bg-white even:bg-gray-100 hover:bg-gray-200"
                  >
                    <td className="border border-gray-300 px-4 py-2 text-left text-blue-900">
                      {school["Bank Name"]}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-left text-blue-900">
                      <a
                        href={getGoogleMapsUrl(school.Address)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="no-underline hover:no-underline text-blue-900"
                      >
                        {school.Address}
                      </a>
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-left text-blue-900">
                      {school["Contact No:"]}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
}

export default OutOfState
